import { render } from "./PortForwarding.vue?vue&type=template&id=fbfa659e&scoped=true"
import script from "./PortForwarding.vue?vue&type=script&lang=js"
export * from "./PortForwarding.vue?vue&type=script&lang=js"

import "./PortForwarding.vue?vue&type=style&index=0&id=fbfa659e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfa659e"]])

export default __exports__